
import { createTheme, ThemeProvider,getContrastRatio,alpha } from '@mui/material/styles';
import {Button, CircularProgress} from "@mui/material";
import secureLocalStorage from 'react-secure-storage';


const settings = secureLocalStorage.getItem("systemSettings");
const settingsInfo = JSON.parse(settings);
// const main = settingsInfo?.mainBackground;
const main = settingsInfo?.mainBackground??"#336767";
const qtMain = alpha(main, 1);

const theme = createTheme({
    palette: {
        qt: {
            main:qtMain,
            light: alpha(main,0.5),
            dark: alpha(main,0.9),
            contrastText: getContrastRatio(qtMain, '#fff') > 4.5 ? '#fff' : '#111',
        },
    },
});

const QtMaterialButton = ({loading,children,variant,startIcon,endIcon,onClick,type,loadingSize}) => {

    return <ThemeProvider theme={theme}>
        {loading ? <CircularProgress color={'inherit'} size={loadingSize ?? 25}/> : <Button className={"w-full"} onClick={onClick} type={type} variant={variant} color={'qt'} endIcon={endIcon}
                 startIcon={startIcon}>{children}</Button>}
    </ThemeProvider>;
}

export default QtMaterialButton;